// action
import {
    GET_SUB_GROUP_LIST,
    GET_SUB_GROUP_LIST_FAIL,
    GET_SUB_GROUP_LIST_SUCCESS,
    GET_SUB_GROUP_LIST_RESET
} from '../action/getSubGroupListAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_SUB_GROUP_LIST:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_SUB_GROUP_LIST_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_SUB_GROUP_LIST_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data.data.result,
            }
        case GET_SUB_GROUP_LIST_RESET:
            return initialState
        default:
            return state
    }
}